// Helpers for the change-first-scorecard action: which form values each checkable field needs,
// completeness checks, and the change-first payload builders.

export const CHANGE_FIRST_FIELDS = ['template', 'budget', 'group'];

// The DB module has no budget on its first Beurteilung.
export const changeFirstFieldsFor = (isDbModuleActive) => CHANGE_FIRST_FIELDS.filter(field => !(isDbModuleActive && field === 'budget'));

// The DB module picks the template via its template group first; the group is a UI-only selector.
export const valueKeysFor = (field, isDbModuleActive) => {
  if (field !== 'template') return [field];
  return isDbModuleActive ? ['balanced_scorecard_template_group', 'balanced_scorecard_template'] : ['balanced_scorecard_template'];
};

export const hasCheckedField = (checked) => CHANGE_FIRST_FIELDS.some(field => checked?.[field]);

export const valuesComplete = (checked, values, isDbModuleActive) => CHANGE_FIRST_FIELDS
  .filter(field => checked?.[field])
  .every(field => valueKeysFor(field, isDbModuleActive).every(key => !!values?.[key]));

// Only checked fields are sent: an absent key tells the backend to keep that value.
const pickChecked = (checked, values) => ({
  ...(checked?.template ? { balanced_scorecard_template: values?.balanced_scorecard_template } : {}),
  ...(checked?.budget ? { budget: values?.budget } : {}),
  ...(checked?.group ? { group: values?.group } : {}),
});

export const buildChangeFirstOverwritePayload = ({ filters, selected, checked, values }) => ({
  filters: filters || [],
  employee_hash_ids: selected,
  ...pickChecked(checked, values),
});

// checked is per employee: { [hash_id]: { template|budget|group: true } }.
export const buildChangeFirstInstancePayload = ({ instanceChecked, instanceValues, checked }) => ({
  updates: instanceChecked.map(hash => ({
    employee_hash_id: hash,
    ...pickChecked(checked?.[hash], instanceValues?.[hash]),
  })),
});
